module.exports = __webpack_public_path__ + "static/media/binnen_keuken.4e909c4f.jpg";